<template>
  <div class="priceMobileWrapper">
    <div v-if="allPlan == null || tablePrice == null" class="priceMobileLoaderWrapper">
      <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
    </div>
    <div v-else class="priceMobileWrapper mt-9">
      <div class="d-flex flex-wrap justify-center align-center">
        <div class="priceMobileCardWrapper mb-3 px-3" v-for="(item, i) in cardItems" :key="i">
          <div class="priceMobileCard">

            <v-card :class="item.focus ? 'priceMobileCardFocus' : 'priceMobileCardTop'">
              <div class="priceMobileCardType">
                {{ item.character }} тэмдэгт
              </div>
              <div style="min-height:100px">
                <div class="mobileListWrapper" v-for="(item, i) in item.planWork" :key="i">
                  <span>
                    <v-icon class="icon">mdi-check</v-icon>
                  </span>
                  <span class="listTitle">{{ $t(item) }}</span>
                </div>
                <div class="d-flex mb-4 justify-center">
                  <span class="price">{{ itemPrice[i]
                  }}</span>
                  <span class="currency">₮</span>
                </div>
                <!-- <v-btn class="btnStyle" @click="jump" :disabled="buyLoading">
                  <span style="color:#ffffff">{{
                      $t("footer.getPlanBtn")
                  }}</span>
                </v-btn> -->
              </div>
            </v-card>
           <!-- <v-card :class="
              item.focus ? 'priceMobileCardFocus' : 'priceMobileCardTop'
            ">
              <div class="priceMobileCardType">
                {{ allPlan[i].Name }}
              </div>
              <div class="d-flex mb-4 justify-center">
                <span class="price">{{
                    getFormatNumber(tablePrice[i + 1][0].PagePrice)
                }}</span>
                <span class="currency">₮</span>
                <span class="day">/ 1 хуудас</span>
              </div>
              <div style="min-height:100px">
                <div class="mobileListWrapper" v-for="(item, i) in item.planWork" :key="i">
                  <span>
                    <v-icon class="icon">mdi-check</v-icon>
                  </span>
                  <span class="listTitle">{{ $t(item) }}</span>
                </div>
              </div>


             <div class="btnWrapper"> -->
                <!-- <v-btn
                  v-if="customerPlan != null"
                  class="btnStyle"
                  @click="showWarningDialog(allPlan[i].ID)"
                  :disabled="customerPlan.PlanID === allPlan[i].ID"
                >
                  {{ log(customerPlan.PlanID, allPlan[i].ID) }}
                  {{
                    customerPlan.PlanID === allPlan[i].ID
                      ? "Идэвхжсэн"
                      : "Идэвхжүүлэх"
                  }}
                </v-btn>
                <v-btn v-else class="btnStyle" @click="jump">Идэвхжүүлэх</v-btn>
              </div> -->
            
            <!-- <div class="priceMobileCardBottom">
              <div class="priceMobileCardBottomTitle">
                Үнийн хөнгөлөлт
                <v-tooltip right>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-icon icon color="#787ff7" v-on="tooltip">mdi-information-outline</v-icon>
                  </template>
                  <span>Олон хуудсаар авбал хямдарна</span>
                </v-tooltip>
              </div>
              <table>
                <tr>
                  <th>Хуудасны тоо</th>
                  <th>Нэгжийн үнэ</th>
                </tr>
                <tr v-for="(sale, i) in tablePrice[allPlan[i].ID]" :key="i">
                  <td v-if="i != 0">{{ sale.PageCount }}+</td>
                  <td v-if="i != 0">{{ getFormatNumber(sale.PagePrice) }}₮</td>
                </tr>
              </table>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="instruction">
        <span style="color:red">*</span> Дээрх үнэд НӨАТ орсон болно.
      </div>
      <div class="instruction">
        <span style="color:red">*</span> "Чимэгэ уншигч" ашиглах эрх нь худалдан
        авсан багцын хугацаандаа хүчинтэй.
      </div> -->
      <!-- <v-row>
        <v-col cols="12">
          <v-card class="instructionCard">
            <div class="instructionCardTitle">ТӨГС ХӨРВҮҮЛЭГ</div>
            <div
              class="instructionCardDesc"
            >Хэрвээ та яарч байвал, танд системийн гаргаж өгсөн бичвэрийг бичлэгтэйгээ тулгаж хянан засварлах цаг байхгүй бол манай мэргэшсэн хянагчид энэ ажлыг таны өмнөөс хийж өгч болно. Энэхүү үйлчилгээгээр, дуу болон дүрс бичлэгийн яриаг бичвэр болгон буулгаад, өгүүлбэр бүрийг бичлэгтэй тулган сонсож, гараар зөв бичих дүрмийн алдаагүй завсарлан, бичлэгт оролцогчдын яриаг ангилан ялгаж, бүрэн гүйцэд бэлэн бичвэрийг бэлдэж өгнө. Танд 99%-ийн чанарыг 3000₮/мин үнээр санал болгож байна.</div>
          </v-card>
        </v-col>
      </v-row>-->

      <!-- <v-dialog v-model="successShowDialog" transition="dialog-top-transition" max-width="600"> -->
        <!-- <template v-slot:default="dialog"> -->
        <!-- <v-card>
          <div class="titleBar">Эрх сунгах</div>
          <v-card-text class="d-flex-column pt-5 align-center">
            <div class="dialogTextStyle" style="margin-left:8px">
              Таны эрх амжилттай сунгагдлаа
            </div>
            <div class="dialogTextStyle">
              Таны "БОЛОР ХЭТЭВЧ"-ээс
              <span class="priceDialogStyle">{{ currentPayPrice }}₮</span>
              хасагдаж, {{ currentPage }} тэмдэгт хөрвүүлэх эрх нэмэгдлээ.
            </div>
          </v-card-text>
          <v-card-actions class="justify-start">
            <v-btn class="btnStyle" @click="redirectPage()">За</v-btn>
          </v-card-actions>
        </v-card> -->
        <!-- </template> -->
      <!-- </v-dialog>
      <v-dialog v-model="warningShowDialog" transition="dialog-top-transition" max-width="400">
        <v-card>
          <div class="titleBar">
            <v-icon color="red">mdi-alert</v-icon>
            <span class="ml-2">Анхааруулга</span>
          </div>
          <v-card-text class="d-flex-column pt-10 align-center">
            <div class="dialogTextStyle">
              Та эрхээ солиход өмнөх эрхийн үлдэгдэл устахыг анхаарна уу.
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="closeBtn" @click="warningShowDialog = false">хаах</v-btn>
            <v-btn class="btnStyle" :disabled="changeLoading" @click="changeCustomerPlan">
              <span v-if="changeLoading">
                <v-progress-circular :size="25" :width="3" color="#ffffff" indeterminate></v-progress-circular>
              </span>
              <span v-else>Идэвхжүүлэх</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!--    <v-dialog
        v-model="errorShowDialog"
        transition="dialog-top-transition"
        max-width="600"
      >
        <v-card>
          <div class="titleBar">Эрх сунгах</div>
          <v-card-text class="d-flex-column pt-5 align-center">
            <div class="dialogTextStyle">
              Таны "БОЛОР ХЭТЭВЧИНД"
              <span class="priceDialogStyle">{{ userBalance }}₮</span> байна.
            </div>
            <div class="dialogTextStyle">
              Таны үлдэгдэл хүрэлцэхгүй байгаа тул "БОЛОР ХЭТЭВЧ"-ээ цэнэглэнэ
              үү. Үүний тулд "ЧИМЭГЭ СИСТЕМС" ХХК-ийн Хаан банкны
              <span class="priceDialogStyle">5629 002 805</span> дансаар
              төлбөрөө шилжүүлнэ. Гүйлгээний утга дээр "Болор бүртгэл" үүсгэсэн
              мэйл хаяг болон утасны дугаараа заавал бичээрэй. Асууж тодруулах
              зүйл гарвал ажлын цагаар
              <span class="priceDialogStyle">89871140</span> дугаарт холбогдоно
              уу.
            </div>
          </v-card-text>
          <v-card-actions class="justify-start">
            <v-btn class="btnStyle" @click="errorShowDialog = false">За</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  name: "Mobile Plan",
  data() {
    return {
      cardItems: [
        {
          character :"500",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"5,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"12,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"25,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"200,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },
        {
          character :"2,000,000",
          planWork: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"],
          focus: false,
        },

      ],
      itemPrice: ["1,000", "5,000", "10,000", "20,000", "100,000", "800,000"],
      // cardItems: [
      //   {
      //     planWork: [
      //       "Зөвхөн бичвэр хөрвүүлнэ",
      //       "Аудио файл хадгалах хугацаа 3-н сар",
      //       "10-аас дээш хуудас авбал хямдарна.",
      //     ],
      //     focus: false,
      //   },
        // {
        //   planWork: [
        //     "Файл, бичвэр хөрвүүлнэ",
        //     "2-4 дахин хурдан хөрвүүлнэ",
        //     "Аудио файл хадгалах хугацаа 1жил",
        //     "10-аас дээш хуудас авбал хямдарна.",
        //   ],
        //   focus: true,
        // },
      // ],
      plans: null,
      successShowDialog: false,
      warningShowDialog: false,
      isPriceModal: false,
      loading: false,
      currentPayPrice: 0,
      currentPage: 0,
      userBalance: 0,
      changeLoading: false,
      customerPlan: null,
    };
  },
  computed: {
    ...mapState(["allPlan", "tablePrice"]),
  },
  mounted() {
    this.token = this.$router.currentRoute.query.token;
    this.getCustomerPlan();
  },

  methods: {
    ...mapActions([
      "showErrorMessage",
      "showSuccessMessage",
      "showWarningMessage",
      "checkError",
    ]),
    getCustomerPlan() {
      const headers = { token: this.token };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getCustomerPlan`, {
          headers,
        })
        .then((response) => {
          this.customerPlan = response.data.Data;
        })
        .catch((error) => {
          console.log(error);
          //   this.checkError(error);
        });
    },

    changeCustomerPlan() {
      this.changeLoading = true;
      const headers = {
        token: this.token,
      };
      axios
        .post(`${process.env.VUE_APP_BASE_URL}/changePlan`, this.changePlanId, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            let plan = this.allPlan.find(
              (plan) => plan.ID == response.data.Data.PlanID
            );
            this.showSuccessMessage({
              message: "Таны эрх " + plan.Name + " болж өөрчлөгдлөө",
              timeout: 3000,
            });
            // this.updateCustomerPlan(response.data.Data);
            this.warningShowDialog = false;
          }
          this.changeLoading = false;
        })
        .catch((error) => {
          this.warningShowDialog = false;
          this.changeLoading = false;
          this.checkError(error);
        });
    },

    getPurchase(pId) {
      const headers = { token: this.token, ptype: pId, quantity: 1 };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/paywithwallet`, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loading = false;
            this.successShowDialog = true;
            this.showSuccessMessage({
              message: "Эрх амжилттай сунгагдлаа",
              timeout: 3000,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.checkError(error);
          this.errorShowDialog = true;
        });
    },
    jump() {
      window.location.href = process.env.VUE_APP_BASE_URL + "/login";
    },

    redirectPage() {
      this.successShowDialog = false;
      if (this.$route.name != "payment") {
        this.$router.push({ name: "groups" });
      }
    },
    getFormatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    showWarningDialog(planId) {
      this.warningShowDialog = true;
      this.changePlanId = planId;
    },
  },
};
</script>
<style scoped>
.priceMobileWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  align-content: center;
}

.priceMobileLoaderWrapper {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.priceMobileCardWrapper {
  width: 380px;
}

@media screen and (max-width: 650px) {
  .priceMobileCardWrapper {
    width: 300px;
  }
}

.priceMobileCard {
  /* min-height: 348px !important; */
  /* padding: 24px; */
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  border-bottom: 2px solid #adb5bd !important;
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #ffffff;
  color: #2a2a2b;
}

.priceMobileCardTop {
  min-height: 348px !important;
  padding: 24px;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  /* border-bottom: 3px solid #adb5bd !important; */
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #f7f6ff;
  color: #2a2a2b;
}

.priceMobileCardBottom {
  padding: 24px;
  font-weight: 500;
  text-align: left;
  line-height: 1.5;
  font-size: 14px;
  color: #2c3e50aa;
}

.priceMobileCardBottomTitle {
  margin-bottom: 12px;
}

/* .priceMobileCard:hover {
  background-color: #ffffff;
  border-bottom: 3px solid #787ff7 !important;
  transition: all 0.5s ease !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
} */

.priceMobileCardFocus {
  padding: 48px 24px;
  box-shadow: 0 0 10px rgba(60, 72, 88, 0.529) !important;
  /* border-bottom: 3px solid #adb5bd !important; */
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #ffffff;
  color: #2a2a2b;
  border: 1px solid #787ff7;
}

.priceMobileCardType {
  font-weight: 700;
  /* color: #787ff7; */
  line-height: 1.5;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.price {
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
  font-size: 48px;
  color: #2c3e50;
}

.currency {
  font-weight: 700;
  line-height: 1.5;
  font-size: 24px;
  color: #2c3e50;
  margin-top: 7px;
}

.day {
  font-weight: 700;
  text-align: left;
  line-height: 1.5;
  font-size: 20px;
  color: #2c3e50;
  margin-top: 11px;
}

.limit {
  font-weight: 500;
  text-align: right;
  line-height: 1.5;
  font-size: 9px;
  color: #2c3e50;
}

.mobileListWrapper {
  display: flex;
  align-items: left;
}

.icon {
  color: #787ff7;
  margin-right: 20px;
}

.listTitle {
  color: #2c3e50a6;
  font-weight: 500;
  line-height: 1.5;
  font-size: 16px;
  text-align: left;
}

.btnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 20px; */
  margin: 20px auto 0px auto;
}

.btnStyle {
  background-color: #787ff7 !important;
  color: #ffffff;
  /* box-shadow: 0 3px 5px 0 rgba(50, 50, 247, 0.3); */
  padding: 8px 20px !important;
  outline: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
}

.instruction {
  display: inline-block;
  text-align: right;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 15px;
  padding-right: 20px;
}

.instructionCard {
  padding: 24px;
  border-bottom: 3px solid #adb5bd !important;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
}

.instructionCard:hover {
  border-bottom: 3px solid #787ff7 !important;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
}

.instructionCardTitle {
  font-weight: 500;
  text-align: left;
  line-height: 1.5;
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 20px;
}

.instructionCardDesc {
  text-align: justify;
  line-height: 1.5;
  font-size: 16px;
  color: #2c3e50;
}

.dialogTextStyle {
  color: #2c3e50;
  /* color: red; */
  font-size: 16px;
}

.titleBar {
  font-weight: 500;
  font-size: 18px;
  border-bottom: 1px solid #e8e8e8;
  height: 58px !important;
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.priceDialogStyle {
  font-weight: 700;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

td,
th {
  border: 1px solid #dddddda7;
  text-align: left;
  padding: 8px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 10px;
  height: 34px !important;
  width: 64px !important;
}
</style>
